import { useEffect, useState } from "react";
import styles from "./index.module.css";

type ProgressBarProps = {
  containerRef: HTMLElement;
};

const ProgressBar = ({ containerRef }: ProgressBarProps) => {
  const [currentInViewStoryReadProgress, setCurrentInViewStoryReadProgress] =
    useState(0);

  useEffect(() => {
    function measureProgress() {
      const articleRect = containerRef.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (!articleRect) {
        setCurrentInViewStoryReadProgress(0);
        return;
      }

      // If article is not in view yet
      if (articleRect.top > windowHeight) {
        setCurrentInViewStoryReadProgress(0);
      }

      // If article is completely viewed
      if (articleRect.bottom <= 0) {
        setCurrentInViewStoryReadProgress(100);
      }

      const scrollableDistance = articleRect.height - windowHeight;

      if (scrollableDistance <= 0) {
        setCurrentInViewStoryReadProgress(articleRect.top <= 0 ? 100 : 0);
      } else {
        const scrollProgress =
          Math.abs(Math.min(0, articleRect.top)) / scrollableDistance;
        setCurrentInViewStoryReadProgress(Math.min(100, scrollProgress * 100));
      }
    }

    document.addEventListener("scroll", measureProgress, { passive: true });
    measureProgress();

    return () => {
      document.removeEventListener("scroll", measureProgress);
    };
  }, [containerRef]);

  if (!currentInViewStoryReadProgress) {
    return;
  }
  return (
    <div className={styles.progress}>
      <div
        className={styles.progressBar}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={currentInViewStoryReadProgress}
        style={{ width: `${currentInViewStoryReadProgress}%` }}
      />
    </div>
  );
};

export default ProgressBar;
